import request from '../utils/request'

export function getOpsTaxonomies(params) {
  return request({
    url: '/api/admin/ops/taxonomies',
    method: 'get',
    params
  })
}

export function createOpsTaxonomy(data) {
  return request({
    url: '/api/admin/ops/taxonomies',
    method: 'post',
    data
  })
}

export function updateOpsTaxonomy(id, data) {
  return request({
    url: `/api/admin/ops/taxonomies/${id}`,
    method: 'put',
    data
  })
}

export function enableOpsTaxonomy(id) {
  return request({
    url: `/api/admin/ops/taxonomies/${id}/enable`,
    method: 'post'
  })
}

export function disableOpsTaxonomy(id) {
  return request({
    url: `/api/admin/ops/taxonomies/${id}/disable`,
    method: 'post'
  })
}

export function sortOpsTaxonomy(id, data) {
  return request({
    url: `/api/admin/ops/taxonomies/${id}/sort`,
    method: 'post',
    data
  })
}

export function deleteOpsTaxonomy(id) {
  return request({
    url: `/api/admin/ops/taxonomies/${id}`,
    method: 'delete'
  })
}
